module.exports = "./src/client/ui/layout/image/logo-space.png?99a1cde139ec28a43bd8d31383bd86c3";